
/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 16/9/2020
 */

import mergeProps from "@/router/utils/mergeProps";
let FormAnswersDetails = () => import(/* webpackChunkName: "ResourcesForms" */   "@/core/modules/coach/Resources/Forms/FormAnswersDetails.vue");

let SafetyRiskWorkflowView = () => import(/* webpackChunkName: "ResourcesForms" */ '@/core/modules/coach/Resources/Workflows/SafetyRiskWorkflowView')
let EscalatedCareWorkflowView = () => import(/* webpackChunkName: "ResourcesForms" */ '@/core/modules/coach/Resources/Workflows/EscalatedCareWorkflowView')
let SafetyCareWorkflowView = () => import(/* webpackChunkName: "ResourcesForms" */ '@/core/modules/coach/Resources/Workflows/SafetyCareWorkflowView')
let DailyLivingWorkflowView = () => import(/* webpackChunkName: "ResourcesForms" */ '@/core/modules/coach/Resources/Workflows/DailyLivingWorkflowView')
let FormQuestionsView = () => import(/* webpackChunkName: "ResourcesForms" */ '@/core/modules/coach/Resources/Forms/FormQuestionsView.vue')
let SignAgreementPage = () => import(/* webpackChunkName: "ResourcesAgreements" */ '@/core/modules/coach/Resources/Agreements/SignAgreementPage.vue')
let EmptyRouterView = () => import(/* webpackChunkName: "ResourceCenter" */ '@/core/components/EmptyRouterView.vue')
const StorageContentPage = () => import(/* webpackChunkName: "Coaching" */ '@/core/recoveryCoachingApp/StorageContentPage')

let WheelOfLifeAssessmentPage = () => import(/* webpackChunkName: "WheelOfLifeTools" */ '@/core/modules/coach/Resources/CoachingTools/WheelOfLife/WheelOfLifeAssessmentPage.vue')
let WheelOfLifeAssessmentResultPage = () => import(/* webpackChunkName: "WheelOfLifeTools" */ '@/core/modules/coach/Resources/CoachingTools/WheelOfLife/WheelOfLifeAssessmentResultPage.vue')
let GenericToolWorkPage = () => import(/* webpackChunkName: "GenericTools" */ '@/core/modules/coach/Resources/CoachingTools/GenericTools/GenericToolWorkPage.vue')
let GenericToolResultPage = () => import(/* webpackChunkName: "GenericTools" */ '@/core/modules/coach/Resources/CoachingTools/GenericTools/GenericToolResultPage.vue')

export default [
	{
		path: "/app/tools/:toolType/work/:ownerId/:toolResultId/result",
		name: "GenericToolResult",
		component: GenericToolResultPage,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	},
	{
		path: "/app/tools/:toolType/work/:ownerId/:toolInstanceId",
		name: "GenericToolWork",
		component: GenericToolWorkPage,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	},
	{
		path: "/app/wheeloflife/assessment/:coachId/:wheelId/result",
		name: "WheelOfLifeAssessmentResult",
		component: WheelOfLifeAssessmentResultPage,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	},
	{
		path: "/app/wheeloflife/assessment/:coachId/:wheelId",
		name: "WheelOfLifeAssessment",
		component: WheelOfLifeAssessmentPage,
		props: mergeProps,
		meta:{
			isWhitelisted: true
		}
	},
	{
		path: '/app/storage',
		name:'StorageContentRoute',
		component: StorageContentPage,
		props: route => ({
			...route.query,
			...route.params,
		}),
		meta:{
			isWhitelisted: true
		}
	},
	{
		path: "/api/public/storage/stream",
		name: "FileStreamApiRoute"
	},
	{
		path: '/app/resources/forms/:coachId/:formId/viewForm',
		name: 'FormQuestionsView',
		props: route => ({
			...route.query,
			...route.params,
			clientId: route.query.clientId || route.query.cid
		}),
		meta:{
			isWhitelisted: true
		},
		component: FormQuestionsView,
	},
	{
		path: '/app/resources/forms/:coachId/:answerId/answers',
		name: 'FormAnswersViewRouteName',
		props: route => ({
			...route.query,
			...route.params,
			clientId: route.query.clientId || route.query.cid,
			hideHeader: true,
		}),
		meta:{
			isWhitelisted: true
		},
		component: FormAnswersDetails,
	},
	{
		path: '/app/workflow/forms/:coachId/:formId/viewForm',
		name: 'SafetyRiskTraumaWorkflowTake',
		props: route => ({
			...route.query,
			...route.params,
			clientId: route.query.clientId || route.query.cid
		}),
		meta:{
			isWhitelisted: true
		},
		component: SafetyRiskWorkflowView,
	},
	{
		path: '/app/workflow',
		component: EmptyRouterView,
		children: [
			{
				path: 'escalatedcareprotocol/:coachId/:legalDocId',
				name: 'EscalatedCareProtocolPath',
				props: route => ({
					...route.query,
					...route.params,
					clientId: route.query.clientId || route.query.cid
				}),
				meta:{
					isWhitelisted: true
				},
				component: EscalatedCareWorkflowView,

			},
			{
				path: 'safetycareprotocol/:coachId/:legalDocId',
				name: 'SafetyCareProtocolPath',
				props: route => ({
					...route.query,
					...route.params,
					clientId: route.query.clientId || route.query.cid
				}),
				meta:{
					isWhitelisted: true
				},
				component: SafetyCareWorkflowView,
			},
			{
				path: 'dailylivingrotocol/:coachId/:dailyLivingId',
				name: 'DailyLivingProtocolPath',
				props: route => ({
					...route.query,
					...route.params,
					clientId: route.query.clientId || route.query.cid
				}),
				meta:{
					isWhitelisted: true
				},
				component: DailyLivingWorkflowView,
			},

		]
	},

	{
		path: '/app/resources/agreements/:coachId/:documentId/sign',
		name: 'SignDocumentPath',
		props: route => ({
			...route.query,
			...route.params
		}),
		meta:{
			isWhitelisted: true
		},
		component: SignAgreementPage,
	},

]
